module.exports = __webpack_public_path__ + "img/norway-transport-accidents-male.fc8860a5.png";